import * as React from "react";

import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import {
  useMediaQuery,
  Box,
  Button,
  Container,
  Link,
  Stack,
  Toolbar,
  Typography,
  useScrollTrigger,
} from "@mui/material";

import AnimateButton from "../components/@extended/AnimateButton";
import Logo from "../components/logo";

import { ThemeMode } from "../types/config";

import { navigateToUrl } from "single-spa";

// ==============================|| COMPONENTS - APP BAR ||============================== //

// elevation scroll
function ElevationScroll({ layout, children, window }: any) {
  const theme = useTheme();

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 10,
    target: window ? window() : undefined,
  });

  const backColorScroll =
    theme.palette.mode === ThemeMode.DARK
      ? theme.palette.grey[50]
      : theme.palette.grey[800];
  const backColor = layout !== "landing" ? backColorScroll : "transparent";

  return React.cloneElement(children, {
    style: {
      backgroundColor: trigger ? backColorScroll : backColor,
    },
  });
}

interface Props {
  handleDrawerOpen?: () => void;
  layout?: string;
}

const Header = ({ handleDrawerOpen, layout, ...others }: Props) => {
  const theme = useTheme();

  const matchDownMd = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <ElevationScroll layout={layout} {...others}>
      <AppBar
        sx={{
          bgcolor: "transparent",
          color: theme.palette.text.primary,
          boxShadow: "none",
        }}
      >
        <Container disableGutters={matchDownMd}>
          <Toolbar sx={{ px: { xs: 1.5, md: 0, lg: 0 }, py: 2 }}>
            <Stack direction="row" sx={{ flexGrow: 1 }} alignItems="center">
              <Typography
                component="div"
                sx={{ textAlign: "left", display: "inline-block" }}
              >
                <Logo reverse to="/" />
              </Typography>
            </Stack>
            <Stack
              direction="row"
              sx={{
                "& .header-link": {
                  px: 1,
                  "&:hover": { color: theme.palette.primary.main },
                },
              }}
              spacing={2}
            >
              {/* <Link
                className="header-link"
                color="white"
                target="_blank"
                underline="none"
              >
                Dashboard
              </Link> */}
              <Button onClick={() => navigateToUrl("/login")}>
                <Link
                  className="header-link"
                  color="white"
                  target="_blank"
                  underline="none"
                  style={{ fontSize: "1.2rem" }}
                >
                  Login
                </Link>
              </Button>

              {/* <Link
                className="header-link"
                color={handleDrawerOpen ? "primary" : "white"}
                underline="none"
              >
                Components
              </Link>
              <Link
                className="header-link"
                color="white"
                href="https://codedthemes.gitbook.io/mantis/"
                target="_blank"
                underline="none"
              >
                Documentation
              </Link> */}
              <Box sx={{ display: "inline-block" }}>
                <AnimateButton>
                  <Button
                    component={Link}
                    disableElevation
                    color="primary"
                    variant="contained"
                    onClick={() => navigateToUrl("/login")}
                    style={{ fontSize: "1.2rem" }}
                  >
                    Entre em contato
                  </Button>
                </AnimateButton>
              </Box>
            </Stack>
          </Toolbar>
        </Container>
      </AppBar>
    </ElevationScroll>
  );
};

Header.defaultProps = {
  layout: "landing",
};

export default Header;
